module.exports = __webpack_public_path__ + "img/5.60955073.jpg";